import $ from 'jquery';
import * as R from 'ramda';
import currentUser from 'system/currentUser';
import features from 'system/features';
import { DPPEventType } from 'utilities/DPP/DPP.types';
import { JsonSafe } from 'utils/JsonSafe';

import xPageId from 'xPageId';
import xTabId from 'xTabId';

const dppUrl = '/api/dpp';
const namespace = 'mcs:front';

const sendEvent = async ({ type, payload }: DPPEventType) => {
    if (!features.isEnabled('DPP')) {
        return false;
    }

    const event = {
        email: currentUser.get('email'),
        location: window.location.href,
        xTabId,
        xPageId,
        ...payload,
    };
    const data = {
        timestamp: getISOString(),
        event_type: `${namespace}:${type}`,
        event: prepareData(event),
    };

    $.ajax({
        type: 'POST',
        url: dppUrl,
        data: JsonSafe.stringify(data),
        contentType: 'application/json',
        headers: { 'Cache-Control': 'no-cache' },
    });
};

function prepareData(data) {
    // DPP принмает только плоский объект с key-value в виде строк
    return R.pipe(
        R.filter(Boolean),
        // @ts-ignore
        R.map(String),
    )(data);
}

function getISOString() {
    const date = new Date();
    return date.toISOString();
}

export const DPP = {
    sendEvent,
};

/**
 * @overview DPP - data platform protocol
 * Система для логирования метрик, событий и ошибок.
 */
